import userRoutes from './userRoutes';
import targetRoutes from './targetRoutes';
import insightRoutes from './insightRoutes';
import trainerRoutes from './trainerRoutes';
import viewerRoutes from './viewerRoutes';
const routes = [...userRoutes, ...targetRoutes, ...insightRoutes, ...trainerRoutes, ...viewerRoutes];
export default routes;
